import React from 'react';
import { useLocation } from 'react-router-dom';
import { resolveHelpSlug } from '../help/help-routes.js';

const HelpContext = React.createContext(null);

export function HelpProvider({ children }) {
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(false);

  const currentSlug = React.useMemo(
    () => resolveHelpSlug(location.pathname),
    [location.pathname],
  );

  const toggleHelp = React.useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  const closeHelp = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = React.useMemo(
    () => ({ isOpen, currentSlug, toggleHelp, closeHelp }),
    [isOpen, currentSlug, toggleHelp, closeHelp],
  );

  return <HelpContext.Provider value={value}>{children}</HelpContext.Provider>;
}

export function useHelp() {
  const context = React.useContext(HelpContext);
  if (!context) {
    throw new Error('useHelp must be used inside HelpProvider');
  }
  return context;
}
